type SetMutating = (partial: { mutating: boolean }) => void

export const createWithMutating =
  (set: SetMutating) =>
  async <T>(fn: () => Promise<T>): Promise<T> => {
    set({ mutating: true })
    try {
      return await fn()
    } finally {
      set({ mutating: false })
    }
  }
